import { FontEnum } from "../../utils/enums/FontEnum";
import { useRef } from "react";

const BaseActionText = ({
    onClick,
    text,
    type,
    color = "#5B21B6"
}) => {
    const fileInputRef = useRef(null);

    const getTextStyle = () => {
        return {
            ...styles.actionText,
            color: color
        };
    };

    const handleOnClick = () => {
        const fileSelectorButtonCondition = (
            (type === "file")
            && (fileInputRef.current)
        );

        if (fileSelectorButtonCondition) {
            fileInputRef.current.click();
        }

        else {
            onClick();
        };
    };

    const handleFileChange = (event) => {
        const files = event.target.files;

        const file = files[0];

        onClick(file);
    };

    return (
        <div
            style={styles.clickable}
            onClick={() => handleOnClick()}
        >
            <p style={getTextStyle()}>
                {text}
            </p>

            {type === "file" && (
                <input
                    type="file"
                    accept="image/png, image/gif, image/jpeg"
                    multiple={false}
                    ref={fileInputRef}
                    style={styles.input}
                    onChange={handleFileChange}
                />
            )}
        </div>
    );
};

export default BaseActionText;

const styles = {
    actionText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "16px",
        fontWeight: 400,
    },
    clickable: {
        cursor: 'pointer'
    },
    input: {
        display: "none"
    }
};